module.exports = __webpack_public_path__ + "img/04.2ca32fb6.jpg";